import React, { useEffect, useState } from 'react';
import { usePatientContactAvailability } from 'infrastructure/hooks/patient/use-patient-contact-availability';
import { weekDaysDataSource } from 'infrastructure/data-sources/week-days';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import BaseButton from 'components/atoms/baseButton';
import PencilIcon from 'components/atoms/icons/pencil.svg?react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import ContactAvailabilityViewDay from './day';

import type { Availability } from 'infrastructure/classes/availability';
import type { IWeekDayItem } from 'infrastructure/data-sources/week-days';

interface IAdminPanelPatientInfoFormProps {
  patientGuid: string;
  withEditBtn?: boolean;
  onEditClick?: () => void;
  disableEditBtn?: boolean;
}

const ContactAvailabilityViewForm: React.FC<IAdminPanelPatientInfoFormProps> = (
  props,
) => {
  const {
    patientGuid,
    withEditBtn = false,
    disableEditBtn,
    onEditClick,
  } = props;

  const [anytime, setAnytime] = useState(false);
  const { t } = useTranslation();

  const { loading, availabilities } = usePatientContactAvailability({
    patientGuid,
  });

  const weekDays = weekDaysDataSource();

  const prepareAvailabilities = (day: IWeekDayItem) => {
    const result: Availability[] = [];
    availabilities.forEach((availability) => {
      if (day.index === availability.day) result.push(availability);
    });

    return result;
  };

  const listStyles = withEditBtn ? s['list-with-edit-item'] : s.list;

  useEffect(() => {
    setAnytime(!availabilities.length);
  }, [loading]);

  return (
    <BaseSpinWrapper spinning={loading}>
      <ul className={listStyles}>
        {weekDays.map((el) => (
          <ContactAvailabilityViewDay
            key={el.index}
            day={el}
            times={prepareAvailabilities(el)}
            anytime={anytime}
          />
        ))}
        {withEditBtn && (
          <BaseButton
            label={t('controls.edit')}
            type="secondary"
            className={s.edit}
            icon={<PencilIcon />}
            onClick={onEditClick}
            disabled={disableEditBtn}
          />
        )}
      </ul>
    </BaseSpinWrapper>
  );
};

export default ContactAvailabilityViewForm;
